import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../dto/data-model.js';
import { MarketingVendorSettings } from './marketing-vendor-settings.js';
import { MarketingVendorType } from './marketing-vendor-type.js';

export class MailerliteSettings extends MarketingVendorSettings {
  static readonly TYPE_ID = 'acae44ecdd004e229eca1833059e79f6';

  constructor(
    public readonly apiKey: string,
  ) {
    super();
  }

  get $typeId(): string {
    return MailerliteSettings.TYPE_ID;
  }

  get type(): MarketingVendorType {
    return MarketingVendorType.Mailerlite;
  }

  static create(args: {
    apiKey: string,
  }): MailerliteSettings {
    return new MailerliteSettings(
        args.apiKey,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): MailerliteSettings {
    return this.create({
      apiKey: MapUtils.getString(map, 'apiKey'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      type: fromEnumAsString(this.type),
      apiKey: this.apiKey,
    };
  }

  clone(): this {
    return MailerliteSettings.create({
      apiKey: this.apiKey,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.apiKey === this.apiKey;
  }
}

export class MailerliteSettingsBuilder extends DataModelBuilder<MailerliteSettings> {
  build(context: SerializationContext, map: SerializedData): MailerliteSettings {
    return MailerliteSettings.fromMap(context, map);
  }
}
